<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">

      <a-form-model-item v-if="form.isPackage == 0" label="已绑定短剧">
        <div v-if="bindVideoList.length">
          <a-tag v-for="video in bindVideoList" :key="video.id">{{ video.videoName }}</a-tag>
        </div>
        <div v-else>
          <span style="color: #aaa">暂无绑定短剧，请在短剧管理中配置</span>
        </div>
      </a-form-model-item>

      <a-form-model-item label="是否合集商品" prop="isPackage">
        <a-radio-group v-model="form.isPackage">
          <a-radio :value="0">否</a-radio>
          <a-radio :value="1">是</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="目标短剧" prop="videoIds" v-if="form.isPackage == 1">
        <a-select v-model="form.videoIds" mode="multiple" showSearch optionFilterProp="children" style="width: 100%"
          placeholder="请选择">
          <a-select-option v-for="(video, index) in videoList" :key="index" :value="video.id">
            {{ video.videoName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>


      <a-form-model-item label="金币价格" prop="price">
        <a-input-number :min="1" v-model="form.price" placeholder="请输入" />
      </a-form-model-item>

      <a-form-model-item label="启用状态" prop="status">
        <a-select v-model="form.status" placeholder="请选择">
          <a-select-option :value="0">启用</a-select-option>
          <a-select-option :value="1">禁用</a-select-option>
        </a-select>
      </a-form-model-item>


      <a-form-model-item label="开始时间" prop="startTime">
        <a-date-picker :allow-clear="true" size="default" v-model="form.startTime" placeholder="开始时间"
          value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm">
        </a-date-picker>
      </a-form-model-item>

      <a-form-model-item label="截止时间" prop="endTime">
        <a-date-picker :allow-clear="true" size="default" v-model="form.endTime" placeholder="截止时间"
          value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm">
        </a-date-picker>
      </a-form-model-item>
      <!-- 
        <a-form-model-item label="繁中文案" prop="content" >
            <a-input v-model="form.content" placeholder="多个短剧使用,隔开"/>
        </a-form-model-item>

        <a-form-model-item label="英文文案" prop="contentEn" >
            <a-input v-model="form.contentEn" placeholder="多个短剧使用,隔开"/>
        </a-form-model-item>

        <a-form-model-item label="日语文案" prop="contentJa" >
            <a-input v-model="form.contentJa" placeholder="多个短剧使用,隔开"/>
        </a-form-model-item>

        <a-form-model-item label="印尼文案" prop="contentId" >
            <a-input v-model="form.contentId" placeholder="多个短剧使用,隔开"/>
        </a-form-model-item>

        <a-form-model-item label="葡语文案" prop="contentPt" >
            <a-input v-model="form.contentPt" placeholder="多个短剧使用,隔开"/>
        </a-form-model-item>

        <a-form-model-item label="西语文案" prop="contentEs" >
            <a-input v-model="form.contentEs" placeholder="多个短剧使用,隔开"/>
        </a-form-model-item> -->
      <!-- 
        <a-form-model-item label="类型" prop="type">
          <a-select placeholder="请选择" v-model="form.imgType">
            <a-select-option :key="1">单部剧</a-select-option>
            <a-select-option :key="2">多部剧</a-select-option>
          </a-select>
        </a-form-model-item> -->

      <a-form-model-item label="繁中图片" prop="image">
        <a-upload listType="picture-card" class="avatar-uploader" :fileList="[]" :showUploadList="false"
          :customRequest="handleChange">
          <img v-if="form.image" :src="form.image" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>


      <a-form-model-item label="英文图片" prop="imageEn">
        <a-upload listType="picture-card" class="avatar-uploader" :fileList="[]" :showUploadList="false"
          :customRequest="handleChangeEn">
          <img v-if="form.imageEn" :src="form.imageEn" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoadingEn ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>


      <a-form-model-item label="日语图片" prop="imageJa">
        <a-upload listType="picture-card" class="avatar-uploader" :fileList="[]" :showUploadList="false"
          :customRequest="handleChangeJa">
          <img v-if="form.imageJa" :src="form.imageJa" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoadingJa ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="印尼图片" prop="imageId">
        <a-upload listType="picture-card" class="avatar-uploader" :fileList="[]" :showUploadList="false"
          :customRequest="handleChangeId">
          <img v-if="form.imageId" :src="form.imageId" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoadingId ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>


      <a-form-model-item label="葡语图片" prop="imagePt">
        <a-upload listType="picture-card" class="avatar-uploader" :fileList="[]" :showUploadList="false"
          :customRequest="handleChangePt">
          <img v-if="form.imagePt" :src="form.imagePt" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoadingPt ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="西语图片" prop="imageEs">
        <a-upload listType="picture-card" class="avatar-uploader" :fileList="[]" :showUploadList="false"
          :customRequest="handleChangeEs">
          <img v-if="form.imageEs" :src="form.imageEs" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoadingEs ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入排序" />
      </a-form-model-item>

      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入备注" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
  
<script>
import { updateVideoProduct, detailVideoProduct, addVideoProduct } from '@/api/videoProduct/videoProduct'
import { listVideo } from "@/api/video/video";
import UploadFileToVOD from "@/api/vod.js"

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      bindVideoList: [],
      submitLoading: false,
      uploadLoading: false,
      uploadLoadingEn: false,
      uploadLoadingJa: false,

      uploadLoadingId: false,
      uploadLoadingPt: false,
      uploadLoadingEs: false,

      process: false,
      formTitle: '',

      uploadSize: 0,
      uploadEnSize: 0,
      uploadJaSize: 0,

      uploadIdSize: 0,
      uploadPtSize: 0,
      uploadEsSize: 0,

      fileList: [],
      type: 0,
      listAll: [],
      isJup: false,
      // 表单参数
      form: {
        id: null,

        sort: null,

        videoIds: null,

        remark: null,

        // 金币价格
        price: 0,

        // 启用状态：0=启用, 1=禁用
        status: 0,

        // 上架/开始时间
        startTime: null,

        // 下架/结束时间
        endTime: null,

        // // 多语言文案
        // content: '',    // 繁中
        // contentEn: '',  // 英文
        // contentJa: '',  // 日语
        // contentId: '',  // 印尼
        // contentPt: '',  // 葡语
        // contentEs: '',  // 西语

        // 多语言图片
        image: null,    // 繁中
        imageEn: null,  // 英文
        imageJa: null,  // 日语
        imageId: null,  // 印尼
        imagePt: null,  // 葡语
        imageEs: null,  // 西语

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        price: [
          { required: true, message: '金币价格不能为空', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '繁中图片不能为空', trigger: 'blur' }
        ],
        imageEn: [
          { required: true, message: '英文图片不能为空', trigger: 'blur' }
        ],
        // content: [
        //     { required: true, message: '繁中文案不能为空', trigger: 'blur' }
        // ],
        // contentEn: [
        //     { required: true, message: '英文文案不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  filters: {},
  created() {
    this.uploadSize = 0
    this.uploadEnSize = 0
    this.uploadJaSize = 0
    this.uploadIdSize = 0
    this.uploadPtSize = 0
    this.uploadEsSize = 0
    this.queryVideoList()
  },
  computed: {},
  watch: {},
  mounted() {
  },

  methods: {
    queryVideoList() {
      const param = {}
      listVideo(param).then(response => {
        this.videoList = response.data
      })
    },
    handleChange(info) {
      this.uploadLoading = true;
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          console.log("上传成功:", fileName);
          this.form.image = fileName[0];
          this.uploadLoading = false;
        }
      });
    },
    handleChangeEn(info) {
      this.uploadLoadingEn = true;
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          console.log(fileName)
          this.form.imageEn = fileName[0];//文件名
          this.uploadLoadingEn = false;
        }
      });
    },

    handleChangeJa(info) {
      this.uploadLoadingJa = true;
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          console.log(fileName)
          this.form.imageJa = fileName[0];//文件名
          this.uploadLoadingJa = false;
        }
      });
    },

    handleChangeId(info) {
      this.uploadLoadingId = true;
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          console.log(fileName)
          this.form.imageId = fileName[0];//文件名
          this.uploadLoadingId = false;
        }
      });
    },

    handleChangePt(info) {
      this.uploadLoadingPt = true;
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          console.log(fileName)
          this.form.imagePt = fileName[0];//文件名
          this.uploadLoadingPt = false;
        }
      });
    },

    handleChangeEs(info) {
      this.uploadLoadingEs = true;
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          console.log(fileName)
          this.form.imageEs = fileName[0];//文件名
          this.uploadLoadingEs = false;
        }
      });
    },

    beforeUpload: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading = false
        return false;
      }
      //TODO 驗證文件大小
    },
    onClose() {
      this.isJup = false
      this.uploadSize = 0
      this.uploadEnSize = 0
      this.uplaodJaSize = 0

      this.uplaodIdSize = 0
      this.uplaodPtSize = 0
      this.uplaodEsSize = 0
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.sort = null,
        this.price = 0,
        this.status = 0,
        this.startTime = null,
        this.endTime = null,
        // this.content = '',    // 繁中
        // this.contentEn = '',  // 英文
        // this.contentJa = '',  // 日语
        // this.contentId = '',  // 印尼
        // this.contentPt = '',  // 葡语
        // this.contentEs = '',  // 西语
        this.image = null,    // 繁中
        this.imageEn = null,  // 英文
        this.imageJa = null,  // 日语
        this.imageId = null,  // 印尼
        this.imagePt = null,  // 葡语
        this.imageEs = null,  // 西语
        this.remark = null,
        this.uploadSize = 0,
        this.uploadEnSize = 0,
        this.uploadJaSize = 0,
        this.uploadIdSize = 0,
        this.uploadPtSize = 0,
        this.uploadEsSize = 0,
        this.form = {
        }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      detailVideoProduct({ "id": id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        if (this.form.isPackage == 1 && typeof this.form.videoIds === 'string') {
          this.form.videoIds = this.form.videoIds.split(',')
          this.bindVideoList = []
        } else {
          // 如果不是合集商品，清空多选
          this.form.videoIds = []
          this.bindVideoList = response.data.videoList || []
        }
      })


    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.isPackage == 1 && Array.isArray(this.form.videoIds)) {
            this.form.videoIds = this.form.videoIds.join(',')
          } else if (this.form.isPackage == 0) {
            this.form.videoIds = ''
          }
          if (this.form.id !== undefined && this.form.id !== null) {
            this.$confirm({
              title: '确认修改',
              content: '请确保商品配置正确，否则短剧无法一次性解锁',
              okText: '确认',
              cancelText: '取消',
              onOk: () => {
                this.submitLoading = true
                updateVideoProduct(this.form)
                  .then(response => {
                    this.$message.success('修改成功', 3)
                    this.open = false
                    this.$emit('ok')
                  })
                  .finally(() => {
                    this.submitLoading = false
                  })
              }
            })
          } else {
            addVideoProduct(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
  